import ColorsList from './ColorsList'

export default ColorsList
